(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/collections/bomben-matches.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/collections/bomben-matches.js'); 
svs.tipset.collections.BombenMatches = Backbone.Collection.extend({
  model: svs.tipset.models.BombenMatch,
  log: new svs.core.log.Logger('svs.tipset.collections.BombenMatches'),

  initialize: function() {
    var self = this,
      bombenMatches =
        svs.tipset.collections.bombenDraws &&
        svs.tipset.collections.bombenDraws.length > 0 &&
        svs.tipset.collections.bombenDraws.getMatchesByDrawNumber(
          svs.tipset.collections.draws.getCurrentDraw().get('bombenDrawNum')
        );

    if (bombenMatches) {
      _.each(bombenMatches, function(match) {
        var newMatch = new svs.tipset.models.BombenMatch(match);
        self.add(newMatch);
      });
    }
  }
});

 })(window);